import { Sidebar } from "primereact/sidebar";
import { getIcons } from "../../../../../../../components/Constant/Constant";
import { plotStatusIds, roadFacingSides } from "../../../../../../../Enum";


import { useState } from "react";
import { formatINR } from "../../../../../../../utils/formatINR";
import ConfirmationModal from "../../../../../../../components/shareableContainer/ConfirmationModal";
import AsteriskStyle from "../../../../../../../components/Form/Tooltip/AsteriskStyle";

const ResalePlotUnitForm = ({
  unit,
  isSliderOpen,
  onHide,
  handleChange,
  handleSave,
  handleCancel,
  isNew = false,
  propertySaleType,
}) => {
  const icons = getIcons();
  const [isModel, setIsModel] = useState(false);
  const [pendingStatusId, setPendingStatusId] = useState(null);

  const isEditStatus = unit?.statusName === "Available" ? false : true;

  const handelConfirmStatus = () => {
    handleChange({
      target: { name: "unitStatus", value: pendingStatusId },
    });
    setIsModel(false);
  };

  return (
    <>
      {!isModel && (
        <Sidebar
          header={
            <div className="flex items-center justify-between w-full">
              <span className="font-semibold text-lg text-customGreen">
                {isNew ? "Add" : "Edit"} Resale Plot Info Details
              </span>
            </div>
          }
          visible={isSliderOpen}
          onHide={onHide}
          style={{ width: "560px" }}
          position="right"
          className="p-sidebar-md"
        >
          <div className="flex flex-col gap-5 p-4">
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Plot Number
                <AsteriskStyle />
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  name="unitNo"
                  disabled={isEditStatus}
                  value={unit.unitNo || ""}
                  onChange={handleChange}
                  maxLength={40}
                  className="w-full px-3 py-2 border  border-gray-300 rounded-md  input-focus"
                  placeholder="Plot Number"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Square Feet
                <AsteriskStyle />
              </label>
              <div className="col-span-8">
                <input
                  type="number"
                  name="sqft"
                  value={unit.sqft === 0 ? "" : unit.sqft}
                  min={1}
                  disabled={isEditStatus}
                  max={999}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d{0,10}(\.\d{0,2})?$/;

                    if (
                      value === "" ||
                      (regex.test(value) && Number(value) >= 0)
                    ) {
                      handleChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  className="w-full px-3 py-2 border no-arrow border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Square Feet"
                />
              </div>
            </div>

            <div className="grid grid-cols-12">
              <label className="col-span-4 text-sm font-medium text-gray-700 mt-2">
                Dimension{" "}
                <span className="text-xs text-customGreen">(In Feet)</span>
                <AsteriskStyle />
              </label>
              <div className="col-span-8">
                <div className="relative w-full h-72 bg-gray-50 rounded-md border flex items-center justify-center p-4">
                  <div className="w-40 h-40 border-4 rounded-md border-customGreen flex flex-col justify-between items-center">
                    {/* North Side Input */}
                    <input
                      type="text"
                      value={unit.northDimension || ""}
                      disabled={isEditStatus}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          handleChange({
                            target: { name: "northDimension", value },
                          });
                        }
                      }}
                      className="absolute top-9 left-1/2 transform -translate-x-1/2 -translate-y-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                      placeholder="FT"
                      maxLength={10}
                    />

                    {/* South Side Input */}
                    <input
                      type="text"
                      value={unit.southDimension || ""}
                      disabled={isEditStatus}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          handleChange({
                            target: { name: "southDimension", value },
                          });
                        }
                      }}
                      className="absolute bottom-9 left-1/2 transform -translate-x-1/2 translate-y-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                      placeholder="FT"
                      maxLength={10}
                    />
                    {/* West Side Input */}
                    <input
                      type="text"
                      value={unit.westDimension || ""}
                      disabled={isEditStatus}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          handleChange({
                            target: { name: "westDimension", value },
                          });
                        }
                      }}
                      className="absolute left-9 top-1/2 transform -translate-y-1/2 -translate-x-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                      placeholder="FT"
                      maxLength={10}
                    />

                    {/* East Side Input */}
                    <input
                      type="text"
                      value={unit.eastDimension || ""}
                      disabled={isEditStatus}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          handleChange({
                            target: { name: "eastDimension", value },
                          });
                        }
                      }}
                      className="absolute right-9 top-1/2 transform -translate-y-1/2 translate-x-1/2 input-focus rounded-md px-2 py-1 text-sm text-center w-16 bg-white"
                      placeholder="FT"
                      maxLength={10}
                    />

                    {/* Labels inside the plot */}
                    <div className="text-xs font-medium text-gray-700 mt-2">
                      North
                    </div>
                    <div className="flex justify-between w-full px-4">
                      <div className="text-xs font-medium text-gray-700">
                        West
                      </div>
                      <div className="text-xs font-medium text-gray-700">
                        East
                      </div>
                    </div>
                    <div className="text-xs font-medium text-gray-700 mb-2">
                      South
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Road Facing Side
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  name="roadFacing"
                  value={unit.roadFacing || ""}
                  disabled={isEditStatus}
                  onChange={handleChange}
                  maxLength={50}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="e.g., North, South, East, West"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Preferred Location Charges
              </label>
              <div className="col-span-8">
                <input
                  type="number"
                  name="preferredLocationCharge"
                  value={
                    unit.preferredLocationCharge == 0
                      ? ""
                      : unit.preferredLocationCharge
                  }
                  disabled={isEditStatus}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  max={5}
                  onWheel={(e) => e.target.blur()}
                  className="w-full px-3 py-2 border no-arrow border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Preferred Location Charges"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Rate Per SQ. FT
                <AsteriskStyle />
              </label>
              <div className="col-span-8">
                <input
                  type="number"
                  name="ratePerSqft"
                  value={unit.ratePerSqft == 0 ? "" : unit.ratePerSqft}
                  disabled={isEditStatus}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  max={5}
                  onWheel={(e) => e.target.blur()}
                  className="w-full px-3 py-2 border no-arrow border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Approx. SQ. FT Price"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Total Price
                <AsteriskStyle />
              </label>
              <div className="col-span-8">
                <input
                  type="text"
                  name="approxTotalPrice"
                  value={formatINR(unit.ratePerSqft * unit.sqft)}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border bg-gray-100 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Approx. Total Price"
                  readOnly
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Government Guideline SQ. FT Price
              </label>
              <div className="col-span-8">
                <input
                  type="number"
                  name="governmentGuideline"
                  value={
                    unit.governmentGuideline === 0
                      ? ""
                      : unit.governmentGuideline
                  }
                  min={0}
                  disabled={isEditStatus}
                  max={20}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,5}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  className="w-full px-3 py-2 border no-arrow border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Government Guideline SQ. FT Price"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Vendor Guideline SQ. FT Price
              </label>
              <div className="col-span-8">
                <input
                  type="number"
                  name="vendorGuideline"
                  value={
                    unit.vendorGuideline === 0 ? "" : unit.vendorGuideline
                  }
                  min={0}
                  disabled={isEditStatus}
                  max={20}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,5}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  className="w-full px-3 py-2 border no-arrow border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Vendor Guideline SQ. FT Price"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Registration Charge
              </label>
              <div className="col-span-8">
                <input
                  type="number"
                  name="registrationCharge"
                  disabled={isEditStatus}
                  value={
                    unit.registrationCharge === 0 ? "" : unit.registrationCharge
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,7}$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  max={20}
                  onWheel={(e) => e.target.blur()}
                  className="w-full px-3 py-2 border no-arrow border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
                  placeholder="Registration Charge"
                />
              </div>
            </div>

            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Status
                <AsteriskStyle />
              </label>
              <div className="col-span-8 relative">
                <select
                  name="unitStatus"
                  value={unit?.unitStatus?.id}
                  disabled={isEditStatus}
                  onChange={(e) => {
                    setPendingStatusId(e.target.value);
                    setIsModel(true);
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 appearance-none bg-gray-50"
                >
                  {plotStatusIds.map((status) => (
                    <option key={status.value} value={status.id}>
                      {status.label}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>

            <button className="text-[16px] font-medium text-green-600 flex items-center">
              Notes
              <svg
                className="w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </button>

            <div className="items-center">
              <div className="col-span-8">
                <textarea
                  type="text"
                  name="notes"
                  maxLength={250}
                  disabled={isEditStatus}
                  value={unit.notes || ""}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md  focus:outline-none"
                  placeholder="Enter any notes about this plot..."
                />
              </div>
            </div>

            {!isEditStatus && (
              <div className="mt-6">
                <button
                  onClick={handleSave}
                  className="w-full py-3 bg-customGreen text-white rounded-md hover:bg-customGreen focus:outline-none  font-medium"
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </Sidebar>
      )}

      <ConfirmationModal
        showModal={isModel}
        title="Change Plot Status"
        message="Are you sure you want to change the plot status?"
        onConfirm={handelConfirmStatus}
        onCancel={() => {
          setIsModel(false);
          setPendingStatusId(null);
        }}
      />
    </>
  );
};

export default ResalePlotUnitForm;